import {
  AlarmClock,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  Ban,
  BarChart3,
  Bell,
  BookOpen,
  Braces,
  Bug,
  Building,
  Building2,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarX,
  CheckCircle,
  CircleX,
  ClipboardCheck,
  Clock,
  CreditCard,
  DollarSign,
  Eye,
  EyeOff,
  FilePen,
  Filter,
  Flag,
  Folder,
  FolderOpen,
  GalleryHorizontalEnd,
  Globe,
  GraduationCap,
  Headphones,
  Home,
  Hourglass,
  IdCard,
  Inbox,
  Info,
  Keyboard,
  Landmark,
  Layers,
  LayoutDashboard,
  LineChart,
  ListChecks,
  Lock,
  type LucideIcon,
  MessageCircle,
  MessagesSquare,
  MoreHorizontal,
  MoreVertical,
  MoveRight,
  Package,
  PauseCircle,
  Pencil,
  Pin,
  Plug,
  RadioTower,
  Receipt,
  RotateCw,
  ScrollText,
  Search,
  Settings,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  SquareArrowRightExit,
  Star,
  Tag,
  Tags,
  Thermometer,
  Trash2,
  TrendingUp,
  Upload,
  User,
  Users,
  Wallet,
  Waypoints,
  Workflow,
  X,
  Zap,
} from 'lucide-react';

/**
 * The lucide icons the app renders, keyed by their lucide name (as published
 * by the library). {@link DynamicIcon} with `library="lucide"` looks a glyph up
 * here by the name you pass — no Material Symbols translation. Add a one-line
 * entry when you need a lucide icon that isn't listed yet.
 */
export const LUCIDE_ICONS: Record<string, LucideIcon> = {
  'alarm-clock': AlarmClock,
  'alert-circle': AlertCircle,
  'alert-octagon': AlertOctagon,
  'alert-triangle': AlertTriangle,
  ban: Ban,
  'bar-chart-3': BarChart3,
  bell: Bell,
  'book-open': BookOpen,
  braces: Braces,
  bug: Bug,
  building: Building,
  'building-2': Building2,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  'calendar-clock': CalendarClock,
  'calendar-days': CalendarDays,
  'calendar-x': CalendarX,
  'check-circle': CheckCircle,
  'circle-x': CircleX,
  'clipboard-check': ClipboardCheck,
  clock: Clock,
  'credit-card': CreditCard,
  'dollar-sign': DollarSign,
  eye: Eye,
  'eye-off': EyeOff,
  'file-pen': FilePen,
  filter: Filter,
  flag: Flag,
  folder: Folder,
  'folder-open': FolderOpen,
  'gallery-horizontal-end': GalleryHorizontalEnd,
  globe: Globe,
  'graduation-cap': GraduationCap,
  headphones: Headphones,
  home: Home,
  hourglass: Hourglass,
  'id-card': IdCard,
  inbox: Inbox,
  info: Info,
  keyboard: Keyboard,
  landmark: Landmark,
  layers: Layers,
  'layout-dashboard': LayoutDashboard,
  'line-chart': LineChart,
  'list-checks': ListChecks,
  lock: Lock,
  'message-circle': MessageCircle,
  'messages-square': MessagesSquare,
  'more-horizontal': MoreHorizontal,
  'more-vertical': MoreVertical,
  'move-right': MoveRight,
  package: Package,
  'pause-circle': PauseCircle,
  pencil: Pencil,
  pin: Pin,
  plug: Plug,
  'radio-tower': RadioTower,
  receipt: Receipt,
  'rotate-cw': RotateCw,
  'scroll-text': ScrollText,
  search: Search,
  settings: Settings,
  'shield-check': ShieldCheck,
  'sliders-horizontal': SlidersHorizontal,
  sparkles: Sparkles,
  'square-arrow-right-exit': SquareArrowRightExit,
  star: Star,
  tag: Tag,
  tags: Tags,
  thermometer: Thermometer,
  'trash-2': Trash2,
  'trending-up': TrendingUp,
  upload: Upload,
  user: User,
  users: Users,
  wallet: Wallet,
  waypoints: Waypoints,
  workflow: Workflow,
  x: X,
  zap: Zap,
};

export const resolveLucideIcon = (name?: string): LucideIcon | undefined =>
  name ? LUCIDE_ICONS[name] : undefined;
